export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.pageCategoryIds = payload;

  return newState;
};
